// extracted by css-extract-rspack-plugin
export default {"header":"GrantDetailsHeader_header__TWzGB"};